import { Spinner } from '@/components/ui/spinner'

type PropsType = {
  size?: 'small' | 'medium' | 'large'
  message?: string
  className?: string
}

const LoadingIndicator = ({ size = 'medium', message, className }: PropsType) => {
  return (
    <div className={`flex flex-col items-center gap-2${className ? ` ${className}` : ''}`}>
      <Spinner size={size} />
      {message && <span className="text-gray-500">{message}</span>}
    </div>
  )
}

export default LoadingIndicator
